import React, { useState, useEffect } from "react";
import { injectIntl } from "react-intl";
import { useLocation } from "react-router";
import { useHistory } from "react-router-dom";
import { Typography, Box, Stack, Button, Snackbar, Alert, Paper } from "@mui/material";
import { IconButtonStyle } from "@/views/CommonComponent/Styled/CommonBackStyled";
import CommonButton from "@/views/CommonComponent/CommonButton";
import CommonDialog from "@/views/CommonComponent/CommonDialog";
import ComfirmDialog from "@/views/CommonComponent/ComfirmDialog";
import { COMMON_UTIL } from "@/common/util/common.util";
import { useToast } from '../../components/useToast';

import {
  ContentsBox,
  LineStyle,
  ListBox,
  TitleText,
  LogoutBtn,
} from "./Styled/SettingStyled";
import { Root } from "@/common/Styled/CommonStyled";
import { inject, observer } from "mobx-react";
import dayjs from "dayjs";
import { TitleStyle, LinkButton } from "@/common/Styled/CommonStyled";
import { Icon } from "@iconify/react";

import { usePenStatus } from "../../nativebridge/PenStatus"; // 커스텀 훅을 import

import {
  connectPokoro,
  stopScan,
  disConnectPokoro,
  customSendToken,
  customSendSetting,
  isConnectedPokoro,
  reqIsConnectedPokoro,
  callBrowser,
} from "../../nativebridge/JsToNative";

import {
  NativeToJsBridge,
  NativeToJsEventName,

} from "../../nativebridge/NativeToJs";
import { isSetting } from "../../nativebridge/JsToNative";
import PokoroConnectLoading from "./PokoroConnectLoading";

export const AndroidPackageName = "com.neolab_soundpen";
export const IosAppId =
  "%ED%8F%AC%EC%BD%94%EB%A1%9C-%EC%BB%A4%EB%84%A5%ED%8A%B8/id6477915377";

export const languageMap = {
  US: "English",
  KR: "한국어",
  JP: "日本語",
  CN: "简体中文",
  ES: "Español",
  DE: "Deutsch",
  XA: "ٱلسُّعُوْدِيَّة",
};

function Setting(props) {
  const [tabValue, setTabValue] = useState("setting");
  const { intl, authStore, homeStore, userStore, languageStore } = props;
  const [open, setOpen] = useState(false);
  const [nickName, setNickName] = useState("POKORO");
  const history = useHistory();
  const location = useLocation();
  const { showSuccessToast, showErrorToast, showDeleteToast } = useToast();

  // 펜 연결 여부 확인
  const { globalPenStatus, setGlobalPenStatus } = usePenStatus();
  // 로딩바
  const [loading, setLoading] = React.useState(false);
  const [disconnect, setDisconnect] = React.useState(false);
  const countryCode = COMMON_UTIL.getCountryCodeFromLanguage(
    languageStore.language
  );

  let lang_system = "";

  let reqSetServer = false;
  // useEffect(() => {
  //   console.log(globalPenStatus);
  //   console.log(`useEffect globalPenStatus${reqSetLangAfterConnect}`);
  //   if (reqSetLangAfterConnect) {
  //     setLangAfterConnect(false);
  //     const settingData = {
  //       messageType: "POKORO2_Settings",
  //       payload: {
  //         lang_system: countryCode,
  //         lang_speaking: globalPenStatus.deviceInfo.lang_speaking,
  //         lang_listening_main: globalPenStatus.deviceInfo.lang_listening_main,
  //         lang_listening_sub: globalPenStatus.deviceInfo.lang_listening_sub,
  //       },
  //     };
  //     const lang_speaking = globalPenStatus.deviceInfo.lang_speaking;
  //     console.log(
  //       `customSendSetting globalPenStatus.deviceInfo.lang_system=${countryCode},lang_speaking=${lang_speaking}`
  //     );

  //     customSendSetting(JSON.stringify(settingData));
  //   }
  // }, [reqSetLangAfterConnect, globalPenStatus]);

  useEffect(() => {
    console.log(
      "userStore.selectedDevice.deviceName=${userStore.selectedDevice.deviceName}"
    );
    setNickName(userStore.selectedDevice.deviceName);
    isSetting(true);
    return () => {
      isSetting(false);
    };
  }, []);

  //항상 페이지 상단
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);

  const getDate = () => {
    const now = dayjs(dayjs().format("YYYY-MM-DD"));
    const firstDate = dayjs(
      dayjs(userStore.selectedDevice.firstUsedDatetime).format("YYYY-MM-DD")
    );
    return now.diff(firstDate, "day");
  };

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClickClose = () => {
    setOpen(false);
  };

  const handleClickLogout = () => {
    authStore.doLogout(() => history.push("/"));
  };


  const handleBack = () => {
    history.push("/home"); 

    // history.goBack();
  };

  const handleClickDisConnect = () => {
    console.log(`=== handleClickDisConnect ${globalPenStatus}`);
    console.log(globalPenStatus);
    disConnectPokoro();
    setGlobalPenStatus((prevStatus) => ({
      ...prevStatus,
      isConnect: false,
    }));
  };
  const onDeviceConnecting = () => {
    // alert("=== onDeviceConnecting");
    console.log("=== onDeviceConnecting");
  };
  const onDeviceConnected = () => {
    // alert("=== onDeviceConnected");
    console.log("=== onDeviceConnected");
    setLoading(false);
    showSuccessToast(
      <span style={{ whiteSpace: "pre-line" }}>
        {intl.formatMessage({ id: "connect_complete_toast" })} {/* 포코로 연결이 완료되었습니다. */}
      </span>
    );

    if (lang_system !== countryCode) {
      console.log("=== onDeviceConnected reqSetLangAfterConnect");
      // setLangAfterConnect(true);
      setGlobalPenStatus((prevStatus) => ({
        ...prevStatus,
        deviceInfo: {
          ...prevStatus.deviceInfo, // spread the previous deviceInfo object
          lang_system: countryCode, // update lang_main
        },
      }));

      const settingData = {
        messageType: "POKORO2_Settings",
        payload: {
          lang_system: countryCode,
          lang_speaking: globalPenStatus.deviceInfo.lang_speaking,
          lang_listening_main: globalPenStatus.deviceInfo.lang_listening_main,
          lang_listening_sub: globalPenStatus.deviceInfo.lang_listening_sub,
        },
      };
      const lang_speaking = globalPenStatus.deviceInfo.lang_speaking;
      console.log(
        `customSendSetting globalPenStatus.deviceInfo.lang_system=${countryCode},lang_speaking=${lang_speaking}`
      );

      customSendSetting(JSON.stringify(settingData));
    }

    setGlobalPenStatus((prevStatus) => ({
      ...prevStatus,
      isConnect: true,
    }));
  };

  const onDeviceDisConnected = () => {
    setLoading(false);
    setGlobalPenStatus((prevStatus) => ({
      ...prevStatus,
      isConnect: false,
    }));
    setDisconnect(true);
  };

  const handleDisconnectDial = () => {
    console.log(`=== handleDisconnectDial `);
    setDisconnect(false);
  };

  const onDeviceConnectFail = () => {
    console.log("=== onDeviceConnectFail");
    setLoading(false);
    showErrorToast(
      <span style={{ whiteSpace: "pre-line" }}>
        {intl.formatMessage({ id: "connectfail_dialog_Title" })}
      </span>
    );
    setGlobalPenStatus((prevStatus) => ({
      ...prevStatus,
      isConnect: false,
    }));
  };
  const onDeviceWifiScanFail = (msg) => {
    // alert(`=== onDeviceWifiScanFail ${msg}`);
    console.log(`=== onDeviceConnectFail ${msg}`);
  };

  const onDeviceWifiScanResult = (jsonStr) => {
    // alert(`=== onDeviceWifiScanResult: ${jsonStr}`);
    console.log(`=== onDeviceWifiScanResult: ${jsonStr}`);
  };

  const onDeviceWifiConnected = () => {
    // alert("=== onDeviceWifiConnected:");
    console.log("=== onDeviceWifiConnected:");
  };

  const onDeviceWifiConnectFail = (msg) => {
    // alert(`=== onDeviceWifiConnectFail ${msg}`);
    console.log(`=== onDeviceWifiConnectFail:${msg}`);
  };

  const onPokoroStatus = (jsonStr) => {
    // alert(`=== onPokoroStatus: ${jsonStr}`);
    console.log(`=== onPokoroStatus: ${jsonStr.jsonStr}`);
    const status = JSON.parse(jsonStr.jsonStr);

    // const countryCode = COMMON_UTIL.getCountryCodeFromLanguage(languageStore.language);

    // if (countryCode !== null && status.payload.deviceInfo.lang_system !== countryCode) {
    //   languageStore.setLanguage(COMMON_UTIL.getLanguageCodeFromCountry(status.payload.deviceInfo.lang_system));
    // }
    const serverList = JSON.parse(localStorage.getItem("_AGENT_SERVER_LIST_"));
    const Server = serverList.find(
      (server) => server.name === status.payload.serverInfo.name
    );
    const ServerUrl = Server ? Server.serverUrl : null;

    console.log(`ServerUrl=${ServerUrl}`);
    setGlobalPenStatus((prevStatus) => ({
      ...prevStatus, // 현재 상태를 복사
      batteryPercentage: status.payload.batteryPercentage,
      storagePercentage: status.payload.storagePercentage,
      ConnectedAP1: status.payload.ConnectedAP1,
      ConnectedAP2: status.payload.ConnectedAP2,
      ConnectedAP3: status.payload.ConnectedAP3,
      deviceInfo: status.payload.deviceInfo,
      serverInfo: {
        ...prevStatus.serverInfo,
        name: status.payload.serverInfo.name,
        url: ServerUrl,
      },
      // deviceInfo: status.payload.deviceInfo,

      name: status.payload.deviceInfo.name,
    }));
    lang_system = status.payload.deviceInfo.lang_system;
    const settingData = {
      messageType: "POKORO2_Settings",
      payload: {
        server_name: status.payload.serverInfo.name,
        server_url: ServerUrl,
      },
    };
    reqSetServer = true;
    customSendSetting(JSON.stringify(settingData));
  };

  const onCustomSendResult = (jsonStr) => {
    const result = JSON.parse(jsonStr.jsonStr);
    console.log(`onCustomSendResult=${result}`);
    if (reqSetServer) {
      reqSetServer = false;
      const authData = {
        messageType: "POKORO2_Auth",
        payload: {
          token: localStorage.getItem("_NDP_ACCESS_TOKEN_"), // 동적으로 주어진 토큰 값
          refreshToken: localStorage.getItem("_NDP_REFRESH_TOKEN_"), // 동적으로 주어진 리프레시 토큰 값
        },
      };
      customSendToken(JSON.stringify(authData));
    }
  };

  useEffect(() => {
    console.log(
      "====isConnectedPokoro: " + isConnectedPokoro()
    );
    if (isConnectedPokoro() === false){
      setGlobalPenStatus((prevStatus) => ({
        ...prevStatus, // 현재 상태를 복사
        isConnect: false, // isConnect 속성만 변경
      }));
    }
    // 신버전 위의 작업을 한번 더 요청함함
    reqIsConnectedPokoro();

    console.log(
      "====_NDP_ACCESS_TOKEN_: " + localStorage.getItem("_NDP_ACCESS_TOKEN_")
    );
    console.log(
      "====_NDP_REFRESH_TOKEN_: " + localStorage.getItem("_NDP_REFRESH_TOKEN_")
    );
    console.log(
      "====_AGENT_SERVER_LIST_: " + localStorage.getItem("_AGENT_SERVER_LIST_")
    );

    //NativeToJsEventOnDeviceConnecting
    NativeToJsBridge.instance.addEventListener(
      NativeToJsEventName.onDeviceConnecting,
      async (event) => {
        onDeviceConnecting();
      }
    );

    //NativeToJsEventOnDeviceConnected
    NativeToJsBridge.instance.addEventListener(
      NativeToJsEventName.onDeviceConnected,
      async (event) => {
        onDeviceConnected();
      }
    );

    //NativeToJsEventOnDeviceDisConnected
    NativeToJsBridge.instance.addEventListener(
      NativeToJsEventName.onDeviceDisConnected,
      async (event) => {
        onDeviceDisConnected();
      }
    );

    //NativeToJsEventOnDeviceConnectFail
    NativeToJsBridge.instance.addEventListener(
      NativeToJsEventName.onDeviceConnectFail,
      async (event) => {
        onDeviceConnectFail();
      }
    );

    //NativeToJsEventOnDeviceWifiScanFail
    NativeToJsBridge.instance.addEventListener(
      NativeToJsEventName.onDeviceWifiScanFail,
      async (event) => {
        const msg = event;
        onDeviceWifiScanFail(msg);
      }
    );

    //NativeToJsEventOnDeviceWifiScanResult
    NativeToJsBridge.instance.addEventListener(
      NativeToJsEventName.onDeviceWifiScanResult,
      async (event) => {
        const jsonStr = event;
        onDeviceWifiScanResult(jsonStr);
      }
    );

    //NativeToJsEventOnDeviceWifiConnected
    NativeToJsBridge.instance.addEventListener(
      NativeToJsEventName.onDeviceWifiConnected,
      async (event) => {
        onDeviceWifiConnected();
      }
    );

    //NativeToJsEventOnDeviceWifiConnectFail
    NativeToJsBridge.instance.addEventListener(
      NativeToJsEventName.onDeviceWifiConnectFail,
      async (event) => {
        const msg = event;
        onDeviceWifiConnectFail(msg);
      }
    );

    //NativeToJsEventOnPokoroStatus
    NativeToJsBridge.instance.addEventListener(
      NativeToJsEventName.onPokoroStatus,
      async (event) => {
        const jsonStr = event;
        onPokoroStatus(jsonStr);
      }
    );

    NativeToJsBridge.instance.addEventListener(
      NativeToJsEventName.onCustomSendResult,
      async (event) => {
        const jsonStr = event;
        onCustomSendResult(jsonStr);
      }
    );

    NativeToJsBridge.instance.addEventListener(
      NativeToJsEventName.onIsPokoroConnect,
      async (event) => {

        console.log("==== onIsPokoroConnect: "+event.isConnect);
        if (event.isConnect === false) {
          setGlobalPenStatus((prevStatus) => ({
            ...prevStatus, // 현재 상태를 복사
            isConnect: false, // isConnect 속성만 변경
          }));
        }
      }
    );

    NativeToJsBridge.instance.addEventListener(
        NativeToJsEventName.onSetPushAgree,
        async (event) => {
          const isAgree = event.isAgree;
          console.log("========NativeToJs=========== isAgree=" + isAgree);
          userStore.updateUserPushAgreement(authStore.loginUser.id, isAgree, () => {
            if (!isAgree) {
              const now = new Date();
              const formattedDate = `${now.getFullYear()}. ${String(now.getMonth() + 1).padStart(2, '0')}. ${String(now.getDate()).padStart(2, '0')}`;
              showDeleteToast(
                  <span style={{ whiteSpace: "pre-line" }}>
                    {intl.formatMessage({ id: "Toast_marketing_notification_off" })} {/* 푸시 알림을 거부했습니다. */}
                    &nbsp;{formattedDate}
                  </span>
              );
            }
          });
        }
    );

    // 컴포넌트 언마운트 시 이벤트 제거
    return () => {
      NativeToJsBridge.instance.removeEventListener(
        NativeToJsEventName.onDeviceConnecting
      );
      NativeToJsBridge.instance.removeEventListener(
        NativeToJsEventName.onDeviceConnected
      );
      NativeToJsBridge.instance.removeEventListener(
        NativeToJsEventName.onDeviceDisConnected
      );
      NativeToJsBridge.instance.removeEventListener(
        NativeToJsEventName.onDeviceConnectFail
      );
      NativeToJsBridge.instance.removeEventListener(
        NativeToJsEventName.onDeviceWifiScanFail
      );
      NativeToJsBridge.instance.removeEventListener(
        NativeToJsEventName.onDeviceWifiScanResult
      );
      NativeToJsBridge.instance.removeEventListener(
        NativeToJsEventName.onDeviceWifiConnected
      );
      NativeToJsBridge.instance.removeEventListener(
        NativeToJsEventName.onDeviceWifiConnectFail
      );
      NativeToJsBridge.instance.removeEventListener(
        NativeToJsEventName.onPokoroStatus
      );
      NativeToJsBridge.instance.removeEventListener(
        NativeToJsEventName.onCustomSendResult
      );
      NativeToJsBridge.instance.removeEventListener(
        NativeToJsEventName.onIsPokoroConnect
      );
      NativeToJsBridge.instance.removeEventListener(
          NativeToJsEventName.onSetPushAgree
      );
      stopScan();
    };
  }, []);

  const handleIconClick = () => {
    const url = 'https://pokoro.notion.site/POKORO-App-1513d084743980acb2a3d6b69acdcf45?pvs=4';

    if (COMMON_UTIL.isWebView()) {
      callBrowser(url);
    } else {
      setTimeout(() => {
        window.open(url, '_blank');
      }, 100);
    }
  };

  const getUnder14Date = () => {
    const today = new Date();
    const year = today.getFullYear() - 14;
    const month = today.getMonth() + 1; // 1~12월
    const day = today.getDate();

    return {
      year: year,
      month: month,
      day: day
    }
  };

  return (
    <Root>
      {tabValue === "setting" && (
        <>
          {loading && (
            <PokoroConnectLoading
              text={intl.formatMessage({
                id: "bluetooth_search",
              })}
            />
          )}

          <TitleStyle>
            <Stack flexDirection='row' gap={1} alignItems='center'>
              <IconButtonStyle onClick={handleBack}>
                <Icon icon='material-symbols:arrow-back-ios-rounded'/>
              </IconButtonStyle>
              {intl.formatMessage({ id: "setting" })}{/* 설정 */}
            </Stack>
          </TitleStyle>

          {/* 포코로 설정 */}
          {COMMON_UTIL.isWebView() &&
              <Box px={2} py={3}>
                <LinkButton
                  to={{ pathname: "/pokoroSetting", state: { from: "setting" } }}
                  sx={{width: "100%"}}
                >
                  <Stack flexDirection="column" alignItems="flex-start" flex={1}>
                    <TitleText>
                      {intl.formatMessage({id: "device_settings"})}{" "} {/* 포코로 설정 */}
                    </TitleText>
                    <Typography variant="caption" color="c.text02">
                      {intl.formatMessage({ id: "device_settings_desc" })} {/* Wi-Fi, 언어 설정 */}
                    </Typography>
                  </Stack>
                  <Icon icon="weui:arrow-outlined" fontSize={20}/>
                </LinkButton>
              </Box>
          }

          <Box width="100%" height="8px" bgcolor="#f0f1f5"></Box>

          {/* APP 설정, 기타, 로그아웃 */}
          <ContentsBox className="setting-box" mb={9}>
            <ListBox>
              <TitleText>
                {intl.formatMessage({ id: "setting_device_management" })} {/* 기기 관리 */}
              </TitleText>
              <Stack>
                <LinkButton to="/deviceList" sx={{ width: "100%" }}>
                  <Stack flexDirection="column" alignItems="flex-start" flex={1}>
                    <Typography variant="body1">
                      {intl.formatMessage({ id: "setting_connected_pokoro_list" })} {/* 연결된 포코로 목록 */}
                    </Typography>
                    <Typography variant="caption" color="#757575">
                      {intl.formatMessage({ id: "setting_pen_info_description" })} {/* 펜 정보 조회 및 관리 */}
                    </Typography>
                  </Stack>
                  <Icon icon="weui:arrow-outlined" fontSize={20} />
                </LinkButton>
              </Stack>
            </ListBox>

            <ListBox>
              <TitleText>
                {intl.formatMessage({ id: "app_settings" })} {/* APP 설정 */}
              </TitleText>
              <Stack>
                <LinkButton to="/appLanguageSetting">
                  <Typography variant="body1">
                    {intl.formatMessage({ id: "language_settings" })} {/* 언어설정 */}
                  </Typography>
                  <Stack flexDirection="row" gap={0.5} alignItems="center">
                    <Typography className="subTxt">
                      {languageStore.getDisplayLanguage} 
                    </Typography>
                    <Icon icon="weui:arrow-outlined" fontSize={20}/>
                  </Stack>
                </LinkButton>
              </Stack>
            </ListBox>

            <ListBox>
              <TitleText>{intl.formatMessage({ id: "etc" })}</TitleText>
              <Stack>
                <LinkButton to="#" onClick={handleIconClick}>
                  {intl.formatMessage({ id: "app_guide" })} {/* 앱 가이드 */}
                  <Icon icon="weui:arrow-outlined" fontSize={20}/>
                </LinkButton>
                <LinkButton to="/pushAgree">
                  {intl.formatMessage({ id: "push_alert" })} {/* 푸시 알림 */}
                <Icon icon="weui:arrow-outlined" fontSize={20}/>
                </LinkButton>
                <LinkButton to="/termsOfUse">
                  {intl.formatMessage({ id: "terms_of_service" })} {/* 약관 및 정책 */}
                  <Icon icon="weui:arrow-outlined" fontSize={20}/>
                </LinkButton>
              </Stack>
            </ListBox>
          </ContentsBox>
          <LogoutBtn>
            <CommonButton
              text={intl.formatMessage({ id: "logout" })} 
              background='#f0f1f5'
              border='none'
              color='#8f8f8f'
              onClick={handleClickOpen}
            />
            <Typography variant="body2" color="#8f8f8f">
              {intl.formatMessage({ id: "account_delete_txt1" })} {/* 서비스를 더이상 이용하고 싶지 않다면 */}
              <LinkButton to="/accountDelete" style={{ color:"#8f8f8f", textDecoration: 'underline'}}>
                {intl.formatMessage({ id: "account_delete_txt2" })} {/* 여기 */}
              </LinkButton> 
              {intl.formatMessage({ id: "account_delete_txt3" })} {/* 를 눌러주세요. */}
            </Typography>
          </LogoutBtn>
        </>
      )}
      <ComfirmDialog
        open={disconnect}
        title={intl.formatMessage({
          id: "setting_complete_Title",
        })} /* 포코로 연결 해제 */
        contents={
          <pre>{intl.formatMessage({ id: "setting_complete_Contents" })}</pre>
        }
        buttonText={intl.formatMessage({ id: "dialog_confirmButton" })}
        onClick={handleDisconnectDial}
      />
      <CommonDialog
        open={open}
        title={intl.formatMessage({
          id: "logout_confirmation",
        })} /* 로그아웃 하시겠습니까? */
        subText={
          <pre>
            {intl.formatMessage({ id: "logout_warning" })}
            {/* 로그아웃 하시게 되면,처음부터 다시 연결해야 합니다. */}
          </pre>
        }
        onClick1={handleClickClose}
        onClick2={handleClickLogout}
        LeftButtonText={intl.formatMessage({ id: "dialog_cancle" })}
        RightButtonText={intl.formatMessage({ id: "logout" })} /* 로그아웃 */
      />
    </Root>
  );
}

export default injectIntl(
  inject("authStore", "homeStore", "userStore", "languageStore")(observer(Setting))
);
